export const navigationViews = {
  SIMPLIFIED: 'simplified',
  ADVANCED: 'advanced',
};
